/**
 * L'Invoice project translations - Validation section
 */

const validation = {
  // General
  required: "Required",
  // Field-specific required messages
  businessNameRequired: "Business Name is required",
  contactPersonRequired: "Contact Person is required",
  emailRequired: "Email is required",
  addressRequired: "Address is required",
  taxNumberRequired: "Tax Number is required",
  postalCodeRequired: "Postal Code is required",
  cityRequired: "City is required",
  countryRequired: "Country is required",
  sendingMethodRequired: "Sending Method is required",
  peppolIdRequired: "Peppol ID is required",
  // Invalid format messages
  emailInvalid: "Email format is invalid",
  sendingMethodInvalid: "Sending Method is invalid",
  peppolIdInvalid: "Peppol ID is invalid",
  peppolIdMustContainColon: "Peppol ID must contain a colon (:)",
  peppolIdIncorrectlySpecified: "Peppol ID was incorrectly specified for customer",
  // Other validation
  invalidMethod: "Invalid method",
};

export default validation;
